module.exports = __webpack_public_path__ + "static/media/Colette Curve Queen Headboard - 155 cm_Dark Brown.6004fa1f.png";